import { render, staticRenderFns } from "./TwoDSelect.vue?vue&type=template&id=354dd575"
import script from "./TwoDSelect.vue?vue&type=script&lang=js"
export * from "./TwoDSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports